/**
 * i18n EN for the Facets system (PBI 79319 — Layer 2).
 */
export default {
  title: 'Facets',
  description:
    'Controlled vocabulary to classify documents and meetings. Chat filters use these Facets to refine retrieval.',
  add: 'New facet',
  edit: 'Edit facet',
  delete: 'Delete',
  enable: 'Enable',
  disable: 'Disable',
  seedDefaults: 'Restore default set',
  empty: 'No facets configured yet.',
  selectorPlaceholder: 'Select facets',
  selectorEmpty: 'No facets available for this organization.',
  fields: {
    name: 'Dimension',
    nameHelp: 'English name, lowercase, no spaces (e.g.: type, format).',
    value: 'Value',
    valueHelp: 'English kebab-case value (e.g.: meeting, release-note).',
    labelName: 'Dimension label',
    labelValue: 'Value label',
    parent: 'Parent facet (optional)',
    parentHelp: 'Optional hierarchy. Marks this facet as a child of another.',
    isActive: 'Active',
    none: 'None',
  },
  confirmDelete: {
    title: 'Delete facet?',
    description:
      'This permanently removes the facet. If it is in use by existing documents, disable it instead.',
  },
  errors: {
    nameRequired: 'Dimension is required.',
    valueRequired: 'Value is required.',
    invalidFormat: 'Use lowercase and kebab-case (letters, digits and hyphens only).',
    generic: 'Failed to save facet.',
    atLeastOneRequiredTitle: 'Facet required',
    atLeastOneRequiredDescription: 'Select at least one facet before submitting.',
  },
  success: {
    created: 'Facet created.',
    updated: 'Facet updated.',
    deleted: 'Facet deleted.',
    seeded: 'Default set restored.',
  },
  labels: {
    type: 'Type',
    format: 'Format',
    status: 'Status',
    values: {
      // type — top-level
      meeting: 'Meeting',
      document: 'Document',
      decision: 'Decision',
      announcement: 'Announcement',
      message: 'Message',
      prompt: 'Prompt',
      // type — children of document
      study: 'Study',
      requirement: 'Requirement',
      report: 'Report',
      proposal: 'Proposal',
      technical: 'Technical Document',
      rfp: 'RFP',
      rfi: 'RFI',
      training: 'Training',
      // type — children of announcement
      'release-note': 'Release Note',
      // format
      summary: 'Summary',
      full: 'Full',
      transcription: 'Transcription',
      outline: 'Outline',
      // status
      draft: 'Draft',
      approved: 'Approved',
      archived: 'Archived',
    } as Record<string, string>,
  },
};
